module.exports = __webpack_public_path__ + "media/images/subscriber-background-54359514e56e2245db1c928161528783.jpg";